/**
 *  <Desription of Service here>
 *
 * @export
 * @class ModalManager
 */
export class ModalManager {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log'];
  public isActive:boolean = false
  public contents: string = ''
  public screenOptions: any

  /**
   * @param {$log} $log - Angular logging Service.
   */
  constructor(public $log: any) {
    this.$log = $log.getInstance('ModalManager', false);
    this.$log.debug('constructor');
  }

  public activate(options) {
    this.$log.debug('show', options)
    //console.log(options)
    if (typeof options === 'string'){
      this.contents = options
    }else{
      this.contents = options.contents
    }
    //this.contents = options.contents
    this.screenOptions = options
    this.isActive = true;
  }

  public dismiss() {
    this.$log.debug('hide')
    this.isActive = false;
  }

};



/** WEBPACK FOOTER **
 ** ./src/common/services/modal-manager/modal-manager.ts
 **/